import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Collapse,
  Box,
  ListItemText,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { contextType, ProblemsContext } from "../Problems";
import { Edit, Delete } from "@mui/icons-material/";
import ProblemsForm from "./ProblemsForm";
import React from "react";
import { useMutation } from "react-query";
import { deleteProblems, getproblems } from "../../../services";
import { useParams } from "react-router-dom";
import { getProblemType } from "../type";
// import LogComonent from "../../layouts/LogComonent";
import moment from "moment";
import usePopup from "../../../../hooks/usePopup";
import Close from "@mui/icons-material/Close";
import EmptyListAlert from "../../layouts/EmptyListAlert";
import HistoryComponent from "../../layouts/HistoryComponent";

const ProblemsTable = () => {
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(-1);
  const { showSnackbar } = usePopup();
  const { tableData, setEdit, edit, setTableData, success } = useContext(
    ProblemsContext
  ) as contextType;
  const { mutate: getProblemList } = useMutation(getproblems, {
    onSuccess: (data) => {
      setTableData(data.response);
    },
  });
  const { mutate: deleteproblem, isLoading: deleteLoading } = useMutation(
    deleteProblems,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          if (encounterId) {
            getProblemList(encounterId);
          }
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 2000,
          });
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
    }
  );
  const { encounterId } = useParams();

  const handleEdit = (data: any) => {
    setEdit({
      ...data,
    });
    setShow(false);
  };

  useEffect(() => {
    if (encounterId) {
      getProblemList(encounterId);
    }
  }, [success]);

  const handleDelete = (item: getProblemType, index: number) => {
    setSelected(index);
    if (encounterId) {
      deleteproblem({ encounterId: encounterId, id: item.id });
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow
              sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
            >
              {heading.map((heading, index) => (
                <TableCell
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                  align="left"
                  key={`heading${index}`}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                <EmptyListAlert
                  alert="No problems"
                  isData={Boolean((tableData?.length || show))}
                  children={
                    !show && (
                      <div className="w-full flex justify-end items-center p-2 gap-3">
                        <Button
                          color="success"
                          endIcon={<AddCircleIcon />}
                          onClick={() => {
                            setShow(true);
                            setEdit(null);
                          }}
                        >
                          add
                        </Button>

                   <div>   
                      {/* <LogComonent title="Problem" field="problems" /> */}
                      <HistoryComponent 
                      logProps={{title:"Problem", field:"problems"}}
                        title="Problems"
                        tableprops={tableProps}/>
                   </div>
                      </div>
                    )
                  }
                />
                <Collapse in={show} timeout="auto" unmountOnExit>
                  <Box>
                    <ProblemsForm close={() => setShow(false)} />
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
            {tableData?.map((item: getProblemType, index: number) => (
              <React.Fragment key={index}>
                <TableRow>
                  <TableCell>
                    <ListItemText
                      primary={`${item?.icdDto?.icdCode}`}
                      secondary={
                        <>
                          <Typography
                            component="span"
                            variant="body2"
                            sx={{ color: "text.primary", display: "inline" }}
                          >
                            - {item?.icdDto?.icdName}
                          </Typography>
                        </>
                      }
                    />
                  </TableCell>
                  <TableCell>{item?.icdSnomedDto?.snomedDescription}</TableCell>
                  <TableCell>{item?.lifeCycleStatusDto?.description}</TableCell>
                  <TableCell>
                    {moment(item?.dateOfOnset, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY")}
                  </TableCell>
                  <TableCell>
                    {edit?.id === item?.id ? (
                      <IconButton
                        color="error"
                        onClick={() => {
                          setEdit(null);
                        }}
                      >
                        <Close />
                      </IconButton>
                    ) : (
                      <IconButton
                        color="primary"
                        onClick={() => handleEdit(item)}
                      >
                        <Edit />
                      </IconButton>
                    )}
                    {deleteLoading && selected == index ? (
                      <CircularProgress size={18} color="error" />
                    ) : (
                      <IconButton
                        color="error"
                        onClick={() => handleDelete(item, index)}
                      >
                        <Delete />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ padding: 0 }} colSpan={heading?.length}>
                    <Collapse
                      in={Boolean(edit) && edit?.id === item?.id}
                      timeout="auto"
                      unmountOnExit
                    >
                      <ProblemsForm close={() => setEdit(null)} />
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ProblemsTable;

const heading = ["Diagnosis", "Problem", "Status", "DateOfOnset", "Options"];

const tableProps=[
  {heading:"Diagnosis",key:"icdDto.icdCode"},
  {heading:"Problem",key:"icdSnomedDto.snomedDescription"},
  {heading:"Status",key:"lifeCycleStatusDto.description"},
  {heading:"DateOfOnset",key:"dateOfOnset"}
]
